import React from 'react'

const VendorScoreCard = () => {
  return (
    <>
        <h4>Vendor Score Card</h4>
    </>
  )
}

export default VendorScoreCard